/* src/app/error/page-notfound.component.scss */
.container-fluid {
  background-color: var(--card);
  color: var(--foreground);
  font-weight: bold;
}
a {
  color: var(--accent-action);
  text-decoration: none;
  font-weight: bold;
}
/*# sourceMappingURL=page-notfound.component-Y5W6JHXX.css.map */
